<template>
  <div class="hello">
     
    <div class="filters container-fluid">
      <div class="search">
        <input @input="debouncedSearch" v-model="searchTerm" type="text" placeholder="Rechercher une affaire...">
        <label class="checkAffaire">
          <select v-if="loggedInRole=='admin'" @change="searchAffaires(currentPage)" v-model="selectedFilter">
            <option value="">Toutes les affaires</option>
            <option value="linked">Liées</option>
            <option value="unlinked">Non-liées</option>
          </select>
          <select @change="onClientChange" v-model="selectedClient">
            <option value="">Tous les clients</option>
            <option v-for="client in clients" :key="client.id" :value="client.cocli">{{ client.nom }}</option>
          </select>
          <select @change="searchAffaires(currentPage)" v-model="selectedCde">
            <option value="">Toutes les commandes</option>
            <option v-for="commande in commandes" :key="commande" :value="commande">{{ commande }}</option>
          </select>
        </label>
       
      </div>
      
      <div class="infosFilters">
        <div  v-if="loggedInRole=='admin'" class="infos">
          <canvas id="affecte"></canvas>
          <canvas id="retard"></canvas>
        </div>
        <div v-if="loggedInRole=='production'" class="infosAffaireProd">
          <p><strong>Salarié :</strong> {{ loggedInNom }} {{ loggedInPrenom }}</p>
          <p><strong>Affaires restants à produire :</strong> {{ infosAffaires1.nb_total_affaires }}</p>
        </div>

        
     
        
        <div v-if="loggedInRole=='production'" class="actionsStatProd">
          <div class="infos mb-3">
            <canvas id="retardProduction"></canvas>
          </div>

        </div>
      </div>

     
    </div>
  
    <!-- Affichage du total des quantités -->
     <div class="container-fluid">
      <div class="total-quantities">
        <p>Total des quantités à produire : <strong>{{ totalQuantitiesAll }}</strong></p>
      </div>
     </div>


    <div class="tabC">
      <div class="top-bar top-bar container-fluid mb-3">
        <div class="sort-bar">
        <span class="">Trier par :</span>
        <button type="button" class="sort-btn" @click="handleColumnSort('naf')">
          N°Affaire
          <span v-if="sortColumn === 'naf'">
            <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10"><path d="M5 2 L8 7 H2 Z"/></svg>
            <svg v-else width="10" height="10" viewBox="0 0 10 10"><path d="M5 8 L2 3 H8 Z"/></svg>
          </span>
        </button>
        <button type="button" class="sort-btn" @click="handleColumnSort('client')">
          Client
          <span v-if="sortColumn === 'client'">
            <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10"><path d="M5 2 L8 7 H2 Z"/></svg>
            <svg v-else width="10" height="10" viewBox="0 0 10 10"><path d="M5 8 L2 3 H8 Z"/></svg>
          </span>
        </button>
        <button type="button" class="sort-btn" @click="handleColumnSort('qte')">
          Quantité
          <span v-if="sortColumn === 'qte'">
            <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10"><path d="M5 2 L8 7 H2 Z"/></svg>
            <svg v-else width="10" height="10" viewBox="0 0 10 10"><path d="M5 8 L2 3 H8 Z"/></svg>
          </span>
        </button>
        <button type="button" class="sort-btn" @click="handleColumnSort('delais')">
          Délai
          <span v-if="sortColumn === 'delais'">
            <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10"><path d="M5 2 L8 7 H2 Z"/></svg>
            <svg v-else width="10" height="10" viewBox="0 0 10 10"><path d="M5 8 L2 3 H8 Z"/></svg>
          </span>
        </button>
        <button type="button" class="sort-btn" @click="handleColumnSort('dispo')">
          Disponibilité
          <span v-if="sortColumn === 'dispo'">
            <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10"><path d="M5 2 L8 7 H2 Z"/></svg>
            <svg v-else width="10" height="10" viewBox="0 0 10 10"><path d="M5 8 L2 3 H8 Z"/></svg>
          </span>
        </button>
        <span class="sort-bar-sep">|</span>
        <select @change="searchAffaires(currentPage)" v-model="selectedDateFilter" class="select-date-filter">
          <option value="">Toutes les dates</option>
          <option value="retards_semaine">Retards + Semaine en cours</option>
          <option value="retards_mois">Retards + Mois en cours</option>
          <option disabled>──────────</option>
          <option value="aujourd_hui">Aujourd'hui</option>
          <option value="hier">Hier</option>
          <option value="semaine_cours">Semaine en cours</option>
          <option value="semaine_precedente">Semaine précédente</option>
          <option value="mois_cours">Mois en cours</option>
          <option value="mois_precedent">Mois précédent</option>
          <option value="mois_suivant">Mois suivant</option>
          <option value="mois_flottant">Mois flottant (30j)</option>
          <option value="deux_derniers_mois">Deux derniers mois</option>
          <option value="annee_cours">Année en cours</option>
          <option value="personnalisee">Personnalisée…</option>
        </select>
        <template v-if="selectedDateFilter === 'personnalisee'">
          <input type="date" v-model="customDateFrom" @change="searchAffaires(currentPage)" class="input-date" title="Date de début (délai)" />
          <input type="date" v-model="customDateTo" @change="searchAffaires(currentPage)" class="input-date" title="Date de fin (délai)" />
        </template>
      </div>
      <div class="actionsAdmin">
          <div v-if="nb_pages > 1" class="pagination">
            <div class="pagination-pages">
              <span>Page:</span>
              <select @change="searchAffaires(parseInt($event.target.value))">
                <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
              </select>
              <span>sur {{ nb_pages }}</span>
            </div>
          </div>
          <RouterLink v-if="loggedInRole=='admin' || loggedInRole=='gestion' || loggedInRole=='production' " to="/affaires-soldees"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-archive-fill" viewBox="0 0 16 16">
          <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"/>
          </svg>Affaires soldées</RouterLink>
          <select v-if="loggedInRole=='admin' || loggedInRole=='gestion'" class="actions" @change="handleActions" v-model="listActions">
            <option value="liste">Liste des actions</option>
            <option value="solder">Solder</option>
            <option value="lier">Lier</option>
          </select>
       
        </div>
      </div>
      <div class="row">
        <template v-if="affaires.length === 0">
          <div class="no-articles col-12">Pas d'affaires disponibles.</div>
        </template>
        <template v-else>
          <RouterLink v-for="affaire in affaires" :key="affaire.id" :to="getAffaireLink(affaire)" class="col-xl-3 col-lg-4 col-md-6 col-12 affaire-card-link" style="display: flex;">
            <div v-if="affaire.naf.trim() !== ''" class="affaire-card" style="width: 100%;">
              <div class="card-header">
                
                <div class="code-affaire">
                  <div class="top">
                      <span v-if="loggedInRole=='admin' || loggedInRole=='gestion'" class="checkbox-affaire">
                        <input type="checkbox" v-model="selectedItems" :value="affaire.naf" @click.stop>
                      </span>
                      <span><strong>N°AFFAIRE : </strong>{{ affaire.naf }}</span>
                  </div>
                  <div class="bottom">
                    <span>{{ affaire.cocde }}</span>
                  </div>
                </div>
                <span class="d-flex align-items-center">
                  
                  <span class="equipe-chip ms-2">
                    
                    <span class="equipe-nb">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16" style="margin-right:3px;"><path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/></svg>
                      {{ countEmails(affaire.utilisateur) }}
                    </span>
                  </span>
                </span>
              </div>
              <div class="card-body">
                <div class="content">
                  <div class="card-title">
                    <div class="desa1">{{ affaire.piece }}</div>
                    <div class="desa2">{{ affaire.desa }}</div>
                    <div class="desa2">{{ affaire.desa2 }}</div>
                    <div class="desa3">{{ affaire.desa3 }}</div>
                  </div>
                  <div class="card-infos">
                   
                    <span class="info-chip">Client : <strong>{{ affaire.client }}</strong></span>
                    <span class="info-chip">Quantité restant à produire : <strong>{{ affaire.qte_rest }} sur {{ affaire.qte }}</strong></span>
                    <span class="info-chip">Délai : <strong><span :style="{ color: getDelaiTextColor(affaire) }" :class="isDatePassed(affaire.delais) ? 'expired' : 'nonExpired'">{{ formatDate(affaire.delais) }}</span></strong></span>

                  </div>
                  
                  <div class="row">
                    <div class="col-xl-6">
                        <div v-if="affaire.dispo !== null" class="progress-bar-affaire mt-2">
                          <template v-if="affaire.dispo !== null">
                            {{ affaire.dispo + '%' }}
                          </template>
                          <template v-else-if="isLoading">
                            Chargement...
                          </template>
                          <template v-else>
                            N/A
                          </template>
                          <div class="progress-bg">
                        
                            <div class="progress-fill" :style="{ width: affaire.dispo + '%', background: affaire.dispo >= 80 ? '#00d712' : affaire.dispo >= 40 ? '#ffa600' : 'red' }"></div>
                          </div>
                        </div>
                    </div>
                    <div class="col-xl-6">
                      <div v-if="loggedInRole=='admin' || loggedInRole=='gestion'" class="card-actions mt-2">
                        <span class="">
                          <a href="#" @click.prevent.stop="openPopup(affaire)" class="d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill-add" viewBox="0 0 16 16" style="margin-right:4px;"><path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Zm-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/><path d="M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/></svg>
                            Lier
                          </a>
                        </span>
                        <span class="">
                          <a href="#" @click.prevent.stop="solderAffaire(affaire)" class="d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-check-fill" viewBox="0 0 16 16" style="margin-right:4px;"><path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-5.146-5.146-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708z"/></svg>
                            Solder
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <span class="dispo-couvert">
                    <span :class="getDelaiColor(affaire)"></span>
                  </span>
              </div>
            </div>
          </RouterLink>
        </template>
      </div>
    </div>
   


    <div v-if="nb_pages > 1" class="pagination container mt-4">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchAffaires(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>
    <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <div id="loading"></div>
    </div>


      <!-- Popup -->
    <div v-if="popupOpen" class="popup" >
      <!-- Popup content -->
      <div class="popup-content listPopup">
        <!-- Popup header -->
        <div class="popup-header">
          <h2>Relier ou délier un ou plusieurs utilisateurs à cette affaire</h2>
          <a class="close-button" @click="closePopup">&times;</a>
        </div>

        <!-- Popup body -->
        <div class="popup-body">
          <form @submit.prevent="submit">
            <div>
              <label class="mb-2">Lier ou délier un ou plusieurs utilisateurs :</label>
              <div v-if="confirmationMessage" class="alert alert-success" role="alert">
                {{ confirmationMessage }}
              </div>
              <div class="containerList">
                <div class="line" v-for="user in users" :key="user.id">
                  <label class="check">
                    <input type="checkbox" :value="user.email" v-model="utilisateursSelectionnes" :checked="utilisateursSelectionnes.includes(user.email)">
                    {{ user.nom }} {{ user.prenom }}
                  </label>
                </div>

              </div>
            
            </div>
            <div>
              <input type="hidden" id="affaire" v-model="aff" required>
            </div>
            <button type="submit">Envoyer</button>
          </form>
        </div>
      </div>
    </div>


      <!-- Popup -->
      <div v-if="popupOpen2" class="popup" >
        <!-- Popup content -->
        <div class="popup-content listPopup">
          <!-- Popup header -->
          <div class="popup-header">
            <h2>Relier ou délier un ou plusieurs utilisateurs à ces affaires</h2>
            <button class="close-button" @click="closePopupMasse">&times;</button>
          </div>
  
          <!-- Popup body -->
          <div class="popup-body">
            <form @submit.prevent="submit2">
              <div>
                <label class="mb-2">Lier ou délier un ou plusieurs utilisateurs :</label>
                <div v-if="confirmationMessage" class="alert alert-success" role="alert">
                  {{ confirmationMessage }}
                </div>
                <div class="containerList">
                  <div class="line" v-for="user in users" :key="user.id">
                    <label class="check">
                      <input type="checkbox" :value="user.email" v-model="utilisateursSelectionnes" :checked="utilisateursSelectionnes.includes(user.email)">
                      {{ user.nom }} {{ user.prenom }}
                    </label>
                  </div>
  
                </div>
              
              </div>
              <div>
                <input type="hidden" id="affaire" v-model="aff" required>
              </div>
              <button type="submit">Envoyer</button>
            </form>
          </div>
        </div>
      </div>
  </div>


 
</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'
import Chart from 'chart.js/auto';

export default {
  data() {
    return {
      affaires: [],
      nb_pages:1,
      currentPage: 1,
      searchTerm: '',
      selectedFilter: '',
      selectedClient: '',
      selectedCde: '',
      selectedDateFilter: '',
      customDateFrom: '',
      customDateTo: '',
      isLoading: false,
      confirmationMessage: '',
      errorMessage: '',
      popupOpen: false,
      popupOpen2: false,
      aff: '',
      utilisateursSelectionnes: [],
      infosAffaires: [],
      infosAffaires1: [],
      loggedInRole: null,
      loggedInEmail: null,
      loggedInPrenom: null,
      loggedInNom: null,
      users: [],
      sortColumn: '',
      sortDirection: 'asc',
      selectAll: false,
      selectedItems: [],
      clients: [],
      commandes: [],
      listActions: 'liste',
      dataDispo: [],
      loading: true,
      showCommandeSelect: false,
      searchTimeout: null,
      cancelTokenSource: null,
      requestId: 0,
      totalQuantitiesAll: 0,
    }
  },
  mounted() {

    
    // Récupération des données de l'API PHP
    this.currentPage = parseInt(this.$route.query.page) || 1;
    this.searchTerm = this.$route.query.searchTerm || '';
    this.selectedFilter = this.$route.query.selectedFilter || '';
    this.selectedClient = this.$route.query.selectedClient || '';
    this.selectedCde = this.$route.query.selectedCde || '';
    this.sortColumn = this.$route.query.sortColumn || '';
    this.sortDirection = this.$route.query.sortDirection || '';
    this.selectedDateFilter = this.$route.query.selectedDateFilter || '';
    this.customDateFrom = this.$route.query.customDateFrom || '';
    this.customDateTo = this.$route.query.customDateTo || '';
    
    this.searchAffaires(this.currentPage);
    this.getInfosAffaires();
    this.getInfosAffairesProduction();
    this.getCde();

    axios.get('https://www.simef.fr/espace-client/api/getClients.php')
    .then(response => {
      this.clients = response.data;
    })
    .catch(error => {
      console.error(error);
    }); 


  


    



      
  },
  created() {
  
    const email = VueCookies.get('email')
    if (email) {
      this.loggedInEmail = email
    }
    const role = VueCookies.get('role')
    if (role) {
      this.loggedInRole = role
    }
    
    const nom = VueCookies.get('nom')
    if (nom) {
      this.loggedInNom = nom
    }
    const prenom = VueCookies.get('prenom')
    if (prenom) {
      this.loggedInPrenom = prenom
    }
    
    this.getInfosAffairesProduction();

 
  },
  watch: {
    $route(to) {
      this.currentPage = parseInt(to.query.page) || 1;
      this.searchTerm = to.query.searchTerm || '';
      this.selectedFilter = to.query.selectedFilter || '';
      this.selectedClient = to.query.selectedClient || '';
      this.selectedCde = to.query.selectedCde || '';
      this.sortColumn = to.query.sortColumn || '';
      this.sortDirection = to.query.sortDirection || '';
      this.selectedDateFilter = to.query.selectedDateFilter || '';
      this.customDateFrom = to.query.customDateFrom || '';
      this.customDateTo = to.query.customDateTo || '';
      
      this.searchAffaires(this.currentPage);
    }
    
  },
  
  computed: {
    totalQuantitiesOnPage() {
      return this.affaires.reduce((total, affaire) => {
        const qte = parseInt(affaire.qte) || 0;
        return total + qte;
      }, 0);
    }
  },
  methods: {
    computeDateFilterPayload() {
      const f = this.selectedDateFilter;
      if (!f) return null;
      const now = new Date();
      const y = now.getFullYear(), m = now.getMonth(), d = now.getDate();
      // Format YYYYMMDD pour correspondre au format de la colonne `delais` en base
      const fmt = dt => {
        const yy = dt.getFullYear();
        const mm = String(dt.getMonth() + 1).padStart(2, '0');
        const dd = String(dt.getDate()).padStart(2, '0');
        return `${yy}${mm}${dd}`;
      };
      const today = fmt(now);
      if (f === 'retards_semaine') {
        // Retards + semaine en cours : délai <= fin de semaine
        const day = now.getDay();
        const diffToSun = day === 0 ? 0 : 7 - day;
        const sun = new Date(now); sun.setDate(d + diffToSun);
        return { from: null, to: fmt(sun), mode: 'retards_semaine' };
      }
      if (f === 'retards_mois') {
        // Retards + mois en cours : délai <= fin du mois
        const endOfMonth = fmt(new Date(y, m + 1, 0));
        return { from: null, to: endOfMonth, mode: 'retards_mois' };
      }
      if (f === 'personnalisee') {
        const toYMD = iso => iso ? iso.replace(/-/g, '') : null;
        return this.customDateFrom || this.customDateTo
          ? { from: toYMD(this.customDateFrom), to: toYMD(this.customDateTo), mode: 'range' }
          : null;
      }
      let from, to;
      switch (f) {
        case 'aujourd_hui': from = to = today; break;
        case 'hier': { const h = new Date(now); h.setDate(d - 1); from = to = fmt(h); break; }
        case 'semaine_cours': {
          const day = now.getDay(), diffToMon = day === 0 ? -6 : 1 - day;
          const mon = new Date(now); mon.setDate(d + diffToMon);
          const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
          from = fmt(mon); to = fmt(sun); break;
        }
        case 'semaine_precedente': {
          const day = now.getDay(), diffToMon = day === 0 ? -6 : 1 - day;
          const mon = new Date(now); mon.setDate(d + diffToMon - 7);
          const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
          from = fmt(mon); to = fmt(sun); break;
        }
        case 'mois_cours': from = fmt(new Date(y, m, 1)); to = fmt(new Date(y, m + 1, 0)); break;
        case 'mois_precedent': from = fmt(new Date(y, m - 1, 1)); to = fmt(new Date(y, m, 0)); break;
        case 'mois_suivant': from = fmt(new Date(y, m + 1, 1)); to = fmt(new Date(y, m + 2, 0)); break;
        case 'mois_flottant': { const fl = new Date(now); fl.setDate(d - 30); from = fmt(fl); to = today; break; }
        case 'deux_derniers_mois': from = fmt(new Date(y, m - 2, 1)); to = fmt(new Date(y, m, 0)); break;
        case 'annee_cours': from = fmt(new Date(y, 0, 1)); to = fmt(new Date(y, 11, 31)); break;
        default: return null;
      }
      return from && to ? { from, to, mode: 'range' } : null;
    },
    debouncedSearch() {
      // Annuler le timeout précédent
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      // Créer un nouveau timeout
      this.searchTimeout = setTimeout(() => {
        this.searchAffaires(this.currentPage);
      }, 300); // 300ms de délai
    },
    
    onClientChange() {
      // Mettez en place la logique pour déterminer si le select "commande" doit être affiché ou non.
      // Par exemple, si selectedClient a une valeur, vous pouvez choisir d'afficher le select "commande".
      this.showCommandeSelect = !!this.selectedClient;
      
      // Appelez la méthode de recherche avec la page actuelle.
      this.debouncedSearch();
      console.log(this.currentPage);
      this.$router.push({
       
      query: {
        page: this.currentPage,
        searchTerm: this.searchTerm,
        selectedFilter: this.selectedFilter,
        selectedClient: this.selectedClient,
        selectedCde: '',
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
        selectedDateFilter: this.selectedDateFilter,
        customDateFrom: this.customDateFrom,
        customDateTo: this.customDateTo,
      }

      });
      this.getCde();
      
    },
    searchAffaires(page) {
      // Annuler la requête précédente si elle existe
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('Nouvelle recherche lancée');
      }

      // Créer un nouveau token d'annulation
      this.cancelTokenSource = axios.CancelToken.source();
      
      // Incrémenter l'ID de requête
      this.requestId++;
      const currentRequestId = this.requestId;
      
      let loggedEmail = ""; // Valeur par défaut
      if (this.loggedInRole == "admin" || this.loggedInRole=='gestion' || this.loggedInRole=='be' || this.loggedInRole=='achats') {
        // Affecter une valeur différente si loggedInRole est "admin"
        loggedEmail = "";
      } else {
        // Affecter la valeur de loggedInEmail si loggedInRole n'est pas "admin"
        loggedEmail = this.loggedInEmail;
      }
      this.isLoading = true; // Show loader
      
      const datePayload = this.computeDateFilterPayload();
      axios.post('https://www.simef.fr/espace-client/api/getAffaires.php', {
        page: page,
        searchTerm: this.searchTerm,
        selectedFilter: this.selectedFilter,
        selectedClient: this.selectedClient,
        selectedCde: this.selectedCde,
        loggedInEmail: loggedEmail,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
        selectedDateFilter: this.selectedDateFilter,
        dateFrom: datePayload ? datePayload.from : '',
        dateTo: datePayload ? datePayload.to : '',
      }, {
        cancelToken: this.cancelTokenSource.token
      })
      .then(response => {
        // Vérifier que c'est bien la dernière requête
        if (currentRequestId === this.requestId) {
          console.log('Réponse API:', response.data); // Debug
          // Rediriger vers une page de confirmation d'inscription
          this.affaires = response.data.affaires;
          this.nb_pages = response.data.nb_pages;
          this.totalQuantitiesAll = response.data.total_quantities_all || 0;
          console.log('Total quantities all:', this.totalQuantitiesAll); // Debug
          this.currentPage = page;
          
          // Récupérer les disponibilités pour toutes les affaires
          this.getDisponibilites();
        }
      })
      .catch(error => {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      })
      .finally(() => {
        // Ne masquer le loader que si c'est la dernière requête
        if (currentRequestId === this.requestId) {
          this.isLoading = false;
        }
      });

      this.$router.push({
      query: {
        page: page,
        searchTerm: this.searchTerm,
        selectedFilter: this.selectedFilter,
        selectedClient: this.selectedClient,
        selectedCde: this.selectedCde,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
        selectedDateFilter: this.selectedDateFilter,
        customDateFrom: this.customDateFrom,
        customDateTo: this.customDateTo,
      }

      });
    },

    getDisponibilites() {
      // Récupérer les NAF de toutes les affaires actuelles
      const nafs = this.affaires.map(affaire => affaire.naf);
      
      if (nafs.length === 0) return;
      
      // Faire un appel pour chaque affaire (ou optimiser avec un appel groupé si l'API le permet)
      nafs.forEach(naf => {
        axios.post('https://www.simef.fr/espace-client/api/getDispos.php', {
          naf: naf
        })
        .then(response => {
          // Trouver l'affaire correspondante et mettre à jour sa disponibilité
          const affaire = this.affaires.find(a => a.naf === naf);
          if (affaire && response.data) {
            affaire.dispo = response.data.dispo;
          }
        })
        .catch(error => {
          console.error('Erreur lors de la récupération des disponibilités pour NAF', naf, ':', error);
        });
      });
    },

   
    formatDate(date) {
      // Extraire les parties de la date
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);

      // Concaténer les parties dans l'ordre souhaité
      const formattedDate = `${day}-${month}-${year}`;

      // Renvoyer la date formatée
      return formattedDate;
    },
    isDatePassed(date) {
      const currentDate = new Date(); // Get the current date and time
      currentDate.setHours(0, 0, 0, 0); // Set the time to midnight
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);
      const targetDate = new Date(year, month - 1, day); // Create a valid date object

      // Compare the target date with the current date
      return targetDate < currentDate;
    },
    solderAffaire(affaire) {
      if (confirm("Êtes-vous sûr de solder cette affaire ?")) {
        axios
          .post('https://www.simef.fr/espace-client/api/solderAffaire.php', {
            naf: affaire.naf,
            loggedInPrenom: this.loggedInPrenom,
            loggedInNom : this.loggedInNom
          })
          .then(response => {
            this.confirmationMessage = response.data.success;
            // Remove the archived demande from the demandes array
            const index = this.affaires.indexOf(affaire);
            if (index !== -1) {
              this.affaires.splice(index, 1);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    solderAffaire2() {
      if (confirm("Êtes-vous sûr de solder ces affaires ?")) {
        axios
          .post('https://www.simef.fr/espace-client/api/solderAffaires.php', {
            selectedItems: this.selectedItems,
            loggedInPrenom: this.loggedInPrenom,
            loggedInNom : this.loggedInNom
          })
          .then(response => {
            this.confirmationMessage = response.data.success;
            // Remove the archived demande from the demandes array
            this.affaires = this.affaires.filter(affaire => !this.selectedItems.includes(affaire.naf));
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    getAffaireLink(affaire) {
      // Create the base URL

      var affaireName =  affaire.desa.replace(/\//g, '-').trim();
      var affaireName2 = affaire.desa2.replace(/\//g, '-').trim();
      var affaireName3 =  affaire.desa3.replace(/\//g, '-').trim();
      var client =  affaire.client.replace(/\//g, '-').trim();
      var naf =  affaire.naf.replace(/\//g, '-').trim();

      if (affaireName === '') {
        affaireName = 'empty';
      }
      if (affaireName2 === '') {
        affaireName2 = 'empty';
      }
      if (affaireName3 === '') {
        affaireName3 = 'empty';
      }
      if (client === '') {
        client = 'empty';
      }



      let url = '/affaire/' + affaireName + '/' + affaireName2 + '/' + affaireName3 + '/' + naf  + '/' + client;

      // Add the optional parameters if they are not empty
      // Vérifie si la chaîne est vide après les remplacements
      
      if (this.currentPage) {
        url += '/' + this.currentPage;
      } else {
        url += '/empty';
      }
      if (this.searchTerm) {
        url += '/' + this.searchTerm;
      } else {
        url += '/empty';
      }
      if (this.selectedFilter) {
        url += '/' + this.selectedFilter;
      } else {
        url += '/empty';
      }
      if (this.selectedClient) {
        url += '/' + this.selectedClient;
      } else {
        url += '/empty';
      }
      if (this.selectedCde) {
        url += '/' + this.selectedCde;
      } else {
        url += '/empty';
      }
      if (this.sortColumn) {
        url += '/' + this.sortColumn;
      } else {
        url += '/empty';
      }
      if (this.sortDirection) {
        url += '/' + this.sortDirection;
      } else {
        url += '/empty';
      }
      // Return the final URL
      return url;
    },
    openPopup(affaire) {
      this.confirmationMessage = '';
      this.aff = affaire.naf;
      axios.post('https://www.simef.fr/espace-client/api/getAllUtilisateurs.php', {
      })
      .then(response => {
          this.users = response.data;
      })
      .catch(error => {
          console.log(error);
          
      });

       // Envoyer les données d'inscription au serveur
      axios.post('https://www.simef.fr/espace-client/api/getUtilisateursRelies.php', {
        affaire: affaire.naf
      })
      .then(response => {
        this.utilisateursSelectionnes = response.data.split(',');
        console.log(this.utilisateursSelectionnes);
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
          
      });

      this.popupOpen = true;
      this.popupArticle = affaire;
    },
    

    openPopupMasse() {
      this.confirmationMessage = '';

      axios.post('https://www.simef.fr/espace-client/api/getAllUtilisateurs.php', {
      })
      .then(response => {
          this.users = response.data;
      })
      .catch(error => {
          console.log(error);
          
      });

      // Envoyer les données d'inscription au serveur
      axios.post('https://www.simef.fr/espace-client/api/getUtilisateursRelies.php', {
        selectedItems: this.selectedItems,
      })
      .then(response => {
        this.utilisateursSelectionnes = response.data;

        console.log(response.data);
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
          

      });

      this.popupOpen2 = true;
    },

    closePopup() {
      this.popupOpen = false;
      this.popupArticle = null;
    },
    closePopupMasse() {
      this.popupOpen2 = false;
    },
    submit() {
      const tabUsers = Array.from(this.utilisateursSelectionnes);
      const emailString = tabUsers.join(',').replace(/^,/, ''); // Remove leading comma

      axios.post('https://www.simef.fr/espace-client/api/relierUtilisateur.php', {
        utilisateurs: emailString,
        affaire: this.aff
      })
      .then(response => {
          // Update the "relie" property of the corresponding "affaire" object
        const affaireToUpdate = this.affaires.find(affaire => affaire.naf === this.aff);
        if (affaireToUpdate) {
          affaireToUpdate.relie = response.data.success ? 1 : 0;
        }
        // Rediriger vers une page de confirmation d'inscription
        this.errorMEssage = response.data.error;
        if (Object.hasOwnProperty.call(response.data, 'success')) {
          this.confirmationMessage = response.data.success;
        }
        if (Object.hasOwnProperty.call(response.data, 'success1')) {
          this.confirmationMessage = response.data.success1;
        }

        this.getInfosAffaires();
        this.searchAffaires(this.currentPage);
        this.listActions = '';

      })
      .catch(error => {
        console.error(error);
        this.confirmationMessage = '';
        this.errorMEssage = "Une erreur est survenue";
      });
    },
    submit2() {
          const tabUsers = Array.from(this.utilisateursSelectionnes);
          const emailString = tabUsers.join(',').replace(/^,/, ''); // Remove leading comma

          axios.post('https://www.simef.fr/espace-client/api/relierUtilisateurs.php', {
            utilisateurs: emailString,
            selectedItems: this.selectedItems,
          })
            .then(response => {
              // Update the "relie" property of the corresponding "affaire" object
              this.selectedItems.forEach(selectedItem => {
                const affaireToUpdate = this.affaires.find(affaire => affaire.naf === selectedItem);
                if (affaireToUpdate) {
                  affaireToUpdate.relie = response.data.success ? 1 : 0;
                }
              });
              // Rediriger vers une page de confirmation d'inscription
              this.errorMEssage = response.data.error;
              if (Object.hasOwnProperty.call(response.data, 'success')) {
                this.confirmationMessage = response.data.success;
              }
              if (Object.hasOwnProperty.call(response.data, 'success1')) {
                this.confirmationMessage = response.data.success1;
              }

              this.getInfosAffaires();
              this.searchAffaires(this.currentPage);

              this.listActions = '';

            })
            .catch(error => {
              console.error(error);
              this.confirmationMessage = '';
              this.errorMEssage = "Une erreur est survenue";
            });
    },
    handleColumnSort(column) {
      if (this.sortColumn === column) {
        // Reverse the sorting direction if the same column is clicked again
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // Sort the clicked column in ascending order by default
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }

      // Call the searchArticles method with the current page and sorting parameters
      this.searchAffaires(this.currentPage);
    },
    getInfosAffaires() {
      axios.get('https://www.simef.fr/espace-client/api/getInfosAffaires.php')
      .then(response => {
        this.infosAffaires = response.data;


        // Sélectionnez le canvas sur lequel vous voulez afficher le graphique
        const ctx = document.getElementById('affecte').getContext('2d');
        // Créez un objet de configuration pour votre graphique
        const cfg = {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [this.infosAffaires.nb_affaires_non_reliees, this.infosAffaires.nb_affaires_reliees],
              backgroundColor: [
                '#2b358d',
                '#1d1d20',
              ],
            }],
            labels: ['Non-reliées', 'Reliées'],

          }
        }
        // Créez et affichez le graphique en utilisant la configuration définie
        new Chart(ctx, cfg);


        // Sélectionnez le canvas sur lequel vous voulez afficher le graphique
        const ctx1 = document.getElementById('retard').getContext('2d');
        // Créez un objet de configuration pour votre graphique
        const cfg1 = {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [this.infosAffaires.nb_affaires_en_retard, this.infosAffaires.nb_affaires_en_avance],
              backgroundColor: [
                '#2b358d',
                '#1d1d20',
              ],
            }],
            labels: ['En retard', 'Dans les temps']
          }
        }
        // Créez et affichez le graphique en utilisant la configuration définie
        new Chart(ctx1, cfg1);


      })
      .catch(error => {
        console.error(error);
      });

      
    },
    getInfosAffairesProduction() {
      axios.post('https://www.simef.fr/espace-client/api/getInfosAffairesProduction.php', {
        utilisateur: this.loggedInEmail,
      })
      .then(response => {
        this.infosAffaires1 = response.data;


        // Sélectionnez le canvas sur lequel vous voulez afficher le graphique
        const ctx2 = document.getElementById('retardProduction').getContext('2d');
        // Créez un objet de configuration pour votre graphique
        const cfg2 = {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [this.infosAffaires1.nb_affaires_en_retard, this.infosAffaires1.nb_affaires_en_avance],
              backgroundColor: [
                '#2b358d',
                '#1d1d20',
              ],
            }],
            labels: ['En retard', 'Dans les temps']
          }
        }
        // Créez et affichez le graphique en utilisant la configuration définie
        new Chart(ctx2, cfg2);


      })
      .catch(error => {
        console.error(error);
      });

      
    },
    toggleSelectAll() {
      if (this.selectAll) {
        // Cocher toutes les lignes
        this.selectedItems = this.affaires.map(affaire => affaire.naf);
      } else {
        // Désélectionner toutes les lignes
        this.selectedItems = [];
      }
    },
    handleActions() {
      if (this.listActions !== 'liste') {
        if (this.selectedItems.length === 0) {
          alert("Veuillez sélectionner un ou plusieurs éléments.");
        } else {
          if (this.listActions === 'lier') {
            this.openPopupMasse();
          }
        }
      }
    },
    generateIcons(count) {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
      </svg>`.repeat(count);
    },
    countEmails(emails) {
      if (!emails) return 0;
      return emails.split(',').length;
    },
    getDisponibiliteByNAF(naf) {
      const foundItem = this.dataDispo.find(item => item.naf === naf);
      return foundItem ? foundItem.disponibilite : null;
    },
    getDelaiColor(affaire) {
      // Récupère la date du jour à minuit
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      // Récupère la date du délai de l'affaire
      const year = affaire.delais.substr(0, 4);
      const month = affaire.delais.substr(4, 2);
      const day = affaire.delais.substr(6, 2);
      const delaiDate = new Date(year, month - 1, day);
      // Calcul du nombre de jours entre aujourd'hui et le délai
      const diffTime = delaiDate - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays < 0) {
        return 'redBall'; // Délai dépassé
      } else if (diffDays <= 2) {
        return 'orangeBall'; // Délai à 2 jours ou moins
      } else {
        return 'greenBall'; // Plus de 2 jours avant le délai
      }
    },
    getDelaiTextColor(affaire) {
      // Même logique que getDelaiColor mais retourne une couleur CSS
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const year = affaire.delais.substr(0, 4);
      const month = affaire.delais.substr(4, 2);
      const day = affaire.delais.substr(6, 2);
      const delaiDate = new Date(year, month - 1, day);
      const diffTime = delaiDate - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays < 0) {
        return '#ff0000'; // Rouge
      } else if (diffDays <= 2) {
        return '#ffa600'; // Orange
      } else {
        return '#00d712'; // Vert
      }
    },
    getCde() {
      axios.post('https://www.simef.fr/espace-client/api/getCde.php', {
        client: this.selectedClient,
      })
      .then(response => {
        this.commandes = response.data;
      })
      .catch(error => {
        console.log('Erreur :', error);
      });
    }
    
  },
  
  beforeUnmount() {
    // Nettoyer les timeouts et requêtes en cours
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel('Composant détruit');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  $primary: #2b358d;
  .actionsAdmin {
    display: flex;
    gap: 15px;
    align-items: center;
    @media screen and (max-width:992px) {
        flex-wrap: wrap;
        justify-content: center;
    }
    a {
      margin: 0px!important;
      background: #2b358d;
      color: #fff !important;
      padding: 10px 20px;
      @media screen and (max-width:992px) {
        margin-right: 0px;
        margin-bottom: 15px;
      }
      svg {
        margin-right: 10px;
      }
    }
  }
  .prog {
    width: 100%;
    p {
      margin: 0px;
      margin-bottom: 2px;
      font-size: 0.7rem;
    }
  }
  .progress-bar {
    width: 100%; /* Ajustez la largeur selon votre mise en page */
    height: 10px; /* Ajustez la hauteur selon votre mise en page */
    background-color: #e8e8e8; /* Couleur de fond de la barre */
    span {
      background: #2b358d;
      height: 100%;
    }
  }
  
  
  
  .actions {
    color: #333!important;
  }
  .infosFilters {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    align-items: flex-end;
    @media screen and (max-width:992px) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .infos {
      display: flex;
      @media screen and (max-width:992px) {
        margin-bottom: 20px;
      }
      canvas {
        width: 180px!important;
        height: 180px!important;
      }
    }
    @media screen and (max-width:1250px) {
      justify-content: center;
      margin-bottom: 20px;
    }

  }
  .arrowSort {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    height: 100%;
    svg {
      height: 12px;
    }
  }
  th {
    cursor: pointer;
  }
  .expired {
    color: #1d1d20;
  }
  .nonExpired {
    color: #1d1d20;
  }
  .lie {
    color: #1d1d20;
    svg {
      height: 16px;
      width: 16px;
      margin-right: 5px;
    }
  }
  .bulle {
    background-color: red;
    position: fixed;
    transform: translate(-50%,-50%);
    top: 50%;
    left: 50%;
  }
  .com {
    a {
      height: 100%;
      width: 100%;
      display: flex!important;
      align-items: center;
      justify-content: center;
      svg {
        margin-right: 5px;
        height: 18px;
        widows: 18px;
      }
    }
  }
  #loading {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid rgba(255,255,255,.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
  }
  
  @keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  button {
    background: $primary;
    border: none;
    padding: 12px 20px;
    color: #fff;
  }
  .check {
    margin-right: 10px;
    font-weight: 500;
    @media screen and (max-width:992px) {
      margin-right: 0px;
      margin-top: 10px;
    }
  }
  .pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 60%;
    margin: 0 !important;
    @media screen and (max-width:992px) {
      width: 100%;
      margin-right: 10px;
    }
    span {
      cursor: pointer;
      margin: 3px 4px;
      font-size: 0.9rem;
      font-weight: 500;
    }
    .active {
      color: $primary;
      font-weight: 900;
    }
    select {
      color: #333!important;
      border: 0px;
      padding: 12px 15px;
      margin-right: 10px;
    }
  }

  table.affairesListe {
    width: 100%;
    tbody {
    
      a {
        font-size: 0.9rem;
        color: #2b358d;
        display: contents;
      }
    }
    thead {
      background: #2b358d!important;
      color: #fff!important;
      position: sticky;
      top: 0px;
    }
    th, td {
      padding: 8px;
      font-size: 0.9rem;
      font-weight: 500;
      color: #1d1d20;
    }
    th {
      color: #fff!important;
    }
       .ligne-claire {
      background-color: #f7f7f7;
    }
    .ligne-foncee {
      background-color: #ebebeb;
    }
  }

  .search {
      margin-bottom: 20px!important;
      @media screen and (max-width:992px) {
        input[type="text"] {
            margin-bottom: 10px;
        }
      }
  }
 

  .text-danger {
    color: rgb(255, 17, 17);
  }
  .search {
    input[type="text"], select {
        background: #f5f5f5;
        border: 0px;
        padding: 12px 20px;
        border: 1px solid lightgrey;
        margin-right: 10px;
        &:focus-visible {
          outline: $primary auto 1px;
          border-color: $primary;
          border-radius: 0px;
        }
    }
  }
  .loader {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #0b0b0baa;
    top: 0;
    left: 0;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
z-index: 99999;
  }
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 998!important;
  }
  
  .popup-content {
    max-width: 850px;
    padding: 40px 60px;
    max-height: 90%;
    background-color: #fff;
    border-radius: 0px;
    overflow: scroll;
    @media screen and (max-width:992px) {
      max-width: 90%;
      max-height: 90%;
    }

  }
  
  .popup-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    h2 {
      margin: 0px!important;
    }
  }
  
  .close-button {
    background: none;
    border: none;
    font-size: 30px;
    cursor: pointer;
    padding: 3px 7px!important;
    top: 4%;
    font-size: 1.5rem;
    transform: translateX(-100%);
    left: 98%;
    margin: 0px !important;
    color: #2b358d;
    line-height: 1!important;
  }
  .listPopup {
    max-width: 570px;
  }
  .containerList {
    /* width: 50%; */
    height: 155px;
    overflow-y: scroll;
    border: 0px;
    background: #fff;
    padding-top: 10px;
    padding: 20px;
    scrollbar-width: thin;
    scrollbar-color: #888888 #dddddd;
    .line {
      display: flex;
    }
    input {
      width: inherit;
      margin: 0px!important;
      margin-right: 10px!important;
    }
    .check {
      margin-top: 0px;
    }
  }
  .containerList::-webkit-scrollbar {
    width: 8px; /* Adjust the width of the scrollbar */
  }
  
  .containerList::-webkit-scrollbar-track {
    background-color: #dddddd; /* Color of the track */
  }
  
  .containerList::-webkit-scrollbar-thumb {
    background-color: #888888; /* Color of the thumb */
    border-radius: 4px; /* Adjust the border-radius of the thumb */
  }
  
  .containerList::-webkit-scrollbar-thumb:hover {
    background-color: #555555; /* Color of the thumb on hover */
  }
  .infosAffaireProd {
    text-align: left;
    @media screen and (max-width:992px) {
      text-align: center;
    }
    strong {
      font-weight: 900;
    }
    p {
      margin-bottom: 6px!important;
    }
  }
  .total-quantities {
    background: #f7f7f7;
    padding: 10px 20px;
    margin-bottom: 15px;
    border-left: 4px solid #2b358d;
    
    p {
      margin: 0;
      font-size: 1rem;
      color: #333;
      font-weight: 600;
     
    }
    
    
  }
  .affaire-card-link {
    text-decoration: none;
    color: inherit;
  }
  .affaire-card {
    background: #fff;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    min-height: 180px;
    position: relative;
    transition: box-shadow 0.2s;
    width: 100%;
    border: 1px solid #cbcbcb;
    &:hover {
      box-shadow: 0 4px 16px rgba(43,53,141,0.15);
    }
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0px!important;
    background: #2b358d;
    padding: 10px 20px;
    color: #fff;
  }
  .card-body {
    display: flex;
    height: 100%;
    .content {
      width: 92%;
      padding: 15px
    }
    .dispo-couvert {
      width: 8%;
      margin-left: 0px;
      span {
        height: 100%;
        width: 100% ;
        border-radius: 0px;
        
      }
    }
  }
  .code-affaire {
    font-weight: 700;
    font-size: 1rem;
    color: #fff;
    .top {
      display: flex;
      gap: 10px;
    }
    .bottom {
      text-align: left;
    }
  }
  .dispo-couvert {
    margin-left: 8px;
    display: flex;
    align-items: center;
  }
  .card-title {
    margin-bottom: 10px;
    min-height: 70px;
    .desa1 {
      font-size: 1.1rem;
      font-weight: 700;
      color: #1d1d20;
    }
    .desa2, .desa3 {
      font-size: 0.9rem;
      color: #1d1d20;
      font-weight: 600;
    }
  }
  .card-infos {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
    justify-content: center;
        flex-direction: column;
  }
  .info-chip {
    background: #f5f5f5;
    border-radius: 12px;
    padding: 4px 10px;
    font-size: 0.9rem;
    color: #1d1d20;
    display: flex;
    align-items: center;
    font-weight: 600;
    gap: 3px;
  }
  
  .no-articles {
    grid-column: 1/-1;
    text-align: center;
    color: #888;
    font-size: 1.1rem;
    padding: 32px 0;
  }
  .equipe-chip {
    display: flex;
    align-items: center;
    font-size: 0.95rem;
    color: #1d1d20;
    font-weight: 600;
    background: #fff;
    padding: 3px 14px 3px 10px;
    margin-left: 8px;
    gap: 10px;
    box-shadow: 0 1px 3px rgba(43,53,141,0.06);
  }
  .relie-indicator {
    display: flex;
    align-items: center;
    gap: 3px;
    padding: 2px 7px 2px 2px;
    border-radius: 10px;
    font-size: 0.92em;
    font-weight: 600;
    &.relie {
      background: #7dd100;
      color: #fff;
      svg { color: #fff; }
    }
    &.non-relie {
      background: #fdeaea;
      color: red;
      svg { color: red; }
    }
  }
  .relie-text {
    margin-left: 2px;
    font-size: 0.93em;
  }
  .equipe-nb {
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: 0.95em;
    color: #1d1d20;
    font-weight: 600;
    svg {
      height: 20px;
      width: 20px;
    }
  }
  .progress-bar-affaire {
    width: 100%;
    margin-top: 8px;
    font-weight: 800;
    font-size: 0.8rem;
    .progress-bg {
      width: 100%;
      height: 8px;
      background: #e8e8e8;
      border-radius: 8px;
      position: relative;
      overflow: hidden;
    }
    .progress-fill {
      height: 100%;
      border-radius: 8px;
      transition: width 0.3s;
    }
    .progress-label {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.85rem;
      color: #222;
      font-weight: 700;
      pointer-events: none;
    }
  }
  .checkbox-affaire {
    margin-left: px;
    display: flex;
    align-items: center;
    input[type="checkbox"] {
      width: 18px;
      height: 18px;
      accent-color: #2b358d;
      margin: 0;
    }
  }
  .card-actions {
    display: flex;
    gap: 6px;
    margin-top: 10px;
    flex-wrap: wrap;
    justify-content: center;
    a {
      box-shadow: 1px 1px 3px rgba(43,53,141,0.4);
    }
  }
  .top-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 18px;
  }
  .sort-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    span {
      font-weight: 600;
      color: #2b358d;
      font-size: 1rem;
      svg {
        margin-left: 5px!important;
        margin-right: 0!important;
      }
    }
    .sort-btn {
      background: #2b358d;
      color: #fff;
      border: none;
      border-radius: 0px;
      padding: 6px 14px;
      font-weight: 600;
      font-size: 0.98rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-top: 0px!important;
      svg {
        path {
          fill: #fff;
        }
      }
      &:hover, &.active {
        background: #1d1d20;
      }
    }
    .sort-bar-sep {
      color: #ccc;
      font-weight: 300;
      font-size: 1.2rem;
      padding: 0 4px;
    }
    .select-date-filter {
      background: #f0f3ff;
      border: 1.5px solid $primary;
      border-radius: 4px;
      padding: 5px 12px;
      font-size: 0.95rem;
      font-weight: 600;
      color: $primary;
      cursor: pointer;
      &:focus {
        outline: none;
        border-color: darken($primary, 10%);
      }
    }
    .input-date {
      border: 1.5px solid $primary;
      border-radius: 4px;
      padding: 5px 10px;
      font-size: 0.9rem;
      background: #f0f3ff;
      color: $primary;
      cursor: pointer;
      &:focus {
        outline: none;
        border-color: darken($primary, 10%);
      }
    }
  }
</style>
